export default function PHP_closedir() {
  return (
    <div>
      <h1>PHP_closedir</h1>
    </div>
  );
}
